import { COLORS } from "utils/styles";
/**
 * Entity UIDS
 */
const NAVIGATION = "navigation";
const PRICING_TABLE = "pricing-table";
const BANNER = "banner";
const FEATURE_COMPARISON = "feature-comparison";
const FAQ = "faq";
const TESTIMONIAL = "testimonial";
const CTA = "cta";
const FOOTER = "footer";

/**
 * Entity Labels
 */
const LABEL_NAVIGATION = "Navigation";
const LABEL_PRICING_TABLE = "Pricing Table";
const LABEL_BANNER = "Banner";
const LABEL_FEATURE_COMPARISON = "Feature Comparison";
const LABEL_FAQ = "FAQ";
const LABEL_TESTIMONIAL = "Testimonial";
const LABEL_CTA = "CTA";
const LABEL_FOOTER = "Footer";

export const ENTITY_LABELS = {
  [NAVIGATION]: LABEL_NAVIGATION,
  [PRICING_TABLE]: LABEL_PRICING_TABLE,
  [BANNER]: LABEL_BANNER,
  [FEATURE_COMPARISON]: LABEL_FEATURE_COMPARISON,
  [FAQ]: LABEL_FAQ,
  [TESTIMONIAL]: LABEL_TESTIMONIAL,
  [CTA]: LABEL_CTA,
  [FOOTER]: LABEL_FOOTER
};

export const ENTITY_COLOR_UID_MAP = {
  [NAVIGATION]: COLORS.primary,
  [BANNER]: COLORS.royal_blue,
  [PRICING_TABLE]: COLORS.gold,
  [FEATURE_COMPARISON]: COLORS.forest_green,
  [FOOTER]: COLORS.primary
};

export default {
  NAVIGATION,
  PRICING_TABLE,
  BANNER,
  FEATURE_COMPARISON,
  FAQ,
  TESTIMONIAL,
  CTA,
  FOOTER
};
